export default __webpack_public_path__ + "3445edb14109b8ceaca0c619786cac52.png";